import { render, staticRenderFns } from "./SetAppNotification.vue?vue&type=template&id=457f1ec2&scoped=true"
import script from "./SetAppNotification.vue?vue&type=script&lang=js"
export * from "./SetAppNotification.vue?vue&type=script&lang=js"
import style0 from "./SetAppNotification.vue?vue&type=style&index=0&id=457f1ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457f1ec2",
  null
  
)

export default component.exports